<main id="content" role="main" class="main">
    <script type="text/javascript" async=""
        src="https://www.gstatic.com/recaptcha/releases/x19joXI_IeQnFJ7YnfDapSZq/recaptcha__en.js"
        crossorigin="anonymous"
        integrity="sha384-9OTZ8SiMijeWjnYSXo9GM41sIwr+l2FFUhIAcxbPhIFEgn+MDTrEpzq3Alr7uXd2"></script>
    <script src="https://www.google.com/recaptcha/api.js" type="text/javascript"></script>

    <div class="container-fluid" style="padding-right: 1rem;padding-left: 0.5rem;">
        <div class="row">
            <div class="col-lg-6 d-none d-lg-flex justify-content-center min-vh-lg-100 position-relative px-0"
                style="background:url(../../../assets/images/login-background.jpg) center;background-size:cover;">
                <div class="card pt-md-7 blur px-5 pb-10" *ngIf="isProduction"
                    style="margin-top: 10.5rem;max-width: 23rem;max-height: 23rem;">
                    <div class="text-center mb-5">
                        <img class="img-fluid" [src]="logoPicSrc" alt="Image Description" style="width: 12rem;" data-hs-theme-appearance="default">
                    </div>
                    <div class="mb-5">
                        <h2 class="display-5 text-center">                        {{'investmentLoginDesc'|translate}}

                        </h2>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 d-flex justify-content-center align-items-center min-vh-lg-100">
                <div class="w-100 content-space-t-4 content-space-t-lg-2 content-space-b-1" style="max-width: 25rem;">

                    <form #myForm="ngForm">

                        <div class="text-center">
                            <div class="mb-5">
                                <h1 class="display-4">طلب استعادة كلمة السر</h1>
                            </div>
                        </div>

                        <div class="mb-4 text-end">
                            <div class="mb-3 field-passwordresetrequestform-username required">
                                <label class="form-label" for="passwordresetrequestform-username">الرقم
                                    الوطني/الشخصي</label>

                                <input type="text" name="username" id="username" [(ngModel)]="username"
                                    #username_field="ngModel" class="form-control" required="true">

                                    <span class="text-danger" *ngIf="myForm.submitted && !username_field.valid">{{'requiredField'|translate}}!</span>
                            </div>
                        </div>
                        <div class="d-grid gap-2 mt-3">
                            <div>
                                <div class="grecaptcha-badge" data-style="bottomright"
                                    style="width: 256px; height: 60px; display: block; transition: right 0.3s ease 0s; position: fixed; bottom: 14px; right: -186px; box-shadow: gray 0px 0px 5px; border-radius: 2px; overflow: hidden;">
                                    <div class="grecaptcha-logo"><iframe title="reCAPTCHA"
                                            src="https://www.google.com/recaptcha/api2/anchor?ar=1&amp;k=6LerqC8kAAAAAL0zr64D5T6_bXZYcbbIOkAQw71y&amp;co=aHR0cHM6Ly9tb2luLnJlbGVhbnMuY29tOjQ0Mw..&amp;hl=en&amp;v=x19joXI_IeQnFJ7YnfDapSZq&amp;size=invisible&amp;sa=submit&amp;cb=tibb8wvulhtc"
                                            width="256" height="60" role="presentation" name="a-yqlp59ovp0cr"
                                            frameborder="0" scrolling="no"
                                            sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox allow-storage-access-by-user-activation"></iframe>
                                    </div>
                                    <div class="grecaptcha-error"></div><textarea id="g-recaptcha-response"
                                        name="g-recaptcha-response" class="g-recaptcha-response"
                                        style="width: 250px; height: 40px; border: 1px solid rgb(193, 193, 193); margin: 10px 25px; padding: 0px; resize: none; display: none;"></textarea>
                                </div><iframe style="display: none;"></iframe>
                            </div>

                            <button (click)="checkUsername()" class="btn btn-primary btn-lg g-recaptcha"
                                name="login-button" data-callback="onSubmit" data-action="submit">تحقق</button>
                        </div>
                    </form>
                </div>
            </div>

        </div>

    </div>

</main>


<p-dialog header="التحقق" [(visible)]="visible" [modal]="true" [style]="{ width: '70vw' , direction:'rtl' }" [draggable]="false" [resizable]="true">

    <form #sendOtpForm="ngForm">
        <div class="flex flex-column  gap-3">
    
            <div class="flex align-items-center py-2">
                <p-radioButton name="checkType"  value="1" [(ngModel)]="checkType" inputId="1"></p-radioButton>
                <label for="checkType1" class="px-2">بريد الكتروني</label>
                <p for="checkType1" class="ml-2 py-2" *ngIf="checkType==1">
                    {{emailFirstChar}}
                </p>
    
            </div>
            
            <div class="flex align-items-center py-2">
                <p-radioButton name="checkType" value="2"  [(ngModel)]="checkType" inputId="2"></p-radioButton>
                <label for="checkType2" class="px-2">رقم هاتف</label>
                <p for="checkType2" class="ml-2 py-2" *ngIf="checkType==2">
                    {{phoneFirstChar}}
                </p>
            </div>
    
            <div class="mt-3" *ngIf="checkType==1">
                <input type="text" name="checkStr" id="checkStr" [(ngModel)]="checkStr"
                 #checkStr_field="ngModel" class="form-control" required="true">
    
                 <span class="text-danger" *ngIf="sendOtpForm.submitted && !checkStr_field.valid">{{'requiredField'|translate}}!</span>
            </div>

            <div class="wrapper" style="direction: ltr;" *ngIf="checkType==2">
                <ngx-intl-tel-input
                  [cssClass]="'form-control form-control-lg input-country-code'"
                  [preferredCountries]="preferredCountries"
                  [enableAutoCountrySelect]="true"
                  [enablePlaceholder]="true"
                  [searchCountryFlag]="true"
                  [searchCountryField]="[
                    SearchCountryField.Iso2,
                    SearchCountryField.Name
                  ]"
                  [selectFirstCountry]="true"
                  [selectedCountryISO]="CountryISO.Jordan"
                  [phoneValidation]="false"
                  [separateDialCode]="separateDialCode"
                  [numberFormat]="PhoneNumberFormat.National"
                  name="phoneNumber"
                  [(ngModel)]="phoneNumber"
                  [required]="true"
                >

                </ngx-intl-tel-input>

                <span *ngIf="(phoneNumber==null && sendOtpForm.submitted)" class="text-danger"  >

                    حقل اجباري !
    
                </span>

              </div>

           
    
            <div class="pt-4 text-center">
                <button class="btn btn-primary btn-lg" (click)="sendOtp()"
                name="login-button" data-callback="onSubmit" data-action="submit">ارسال</button>
            </div>
            
        </div>

    </form>

</p-dialog>



<p-dialog header="تغيير كلمة السر" [(visible)]="showChangePasswordForm" [modal]="true" [style]="{ width: '50vw' , direction:'rtl' }" [draggable]="false" [resizable]="false">

    <form #changePasswordForm="ngForm">
        <div class="flex flex-column  gap-3">

            <div class="mt-3">

                <label for="checkType1" class="px-2">رمز التحقق</label>

                <input type="text" name="otp" id="otp" [(ngModel)]="otp"
                #otp_field="ngModel" class="form-control" required="true">

                <span class="text-danger" *ngIf="changePasswordForm.submitted && !otp_field.valid">{{'requiredField'|translate}}!</span>
            </div>

            <div class="mt-3">

                <label for="checkType1" class="px-2">كلمة السر</label>

                <input type="password" name="newPass" id="newPass" [(ngModel)]="newPass" pattern="^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$"
                #newPass_field="ngModel" class="form-control" required="true">

                <span class="text-danger" *ngIf="changePasswordForm.submitted && !newPass_field.valid">{{'requiredField'|translate}}!</span>

                <p class="text-danger" *ngIf="changePasswordForm.submitted && newPass_field?.errors?.['pattern']"> 
                    يجب أن تحتوي كلمة السر على طول لا يقل عن 8 أحرف ومجموعة من الحروف الأبجدية الكبيرة والصغيرة (A-Z وa-z)، بالإضافة إلى أرقام من 0 إلى 9. يمكن أن تتضمن أيضًا رموزًا خاصة مثل !، &#64;، #، $، %    
                </p>
            </div>

            <div class="mt-3">

                <label for="checkType1" class="px-2">اعادة كلمة السر</label>

                <input type="password" name="reNewPass" id="reNewPass" [(ngModel)]="reNewPass" pattern="^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$"
                #reNewPass_field="ngModel" class="form-control" required="true">

                <span class="text-danger" *ngIf="changePasswordForm.submitted && !reNewPass_field.valid">{{'requiredField'|translate}}!</span>

                <p class="text-danger" *ngIf="changePasswordForm.submitted && reNewPass_field?.errors?.['pattern']"> 
                    يجب أن تحتوي كلمة السر على طول لا يقل عن 8 أحرف ومجموعة من الحروف الأبجدية الكبيرة والصغيرة (A-Z وa-z)، بالإضافة إلى أرقام من 0 إلى 9. يمكن أن تتضمن أيضًا رموزًا خاصة مثل !، &#64;، #، $، %    
                </p>
            </div>
    
            <div class="pt-4 text-center">
                <button class="btn btn-primary btn-lg" (click)="changePassword()"
                name="login-button" data-callback="onSubmit" data-action="submit">حفظ</button>
            </div>
            
        </div>

    </form>

</p-dialog>